"use client";

import Link from "next/link";
import notFoundImage from "@/public/images/errors/error-404.png";
import Image from "next/image";
import "@/public/css/global/error.css";
import { useEffect } from "react";

export default function NotFound() {
    const backgroundImage = {
        backgroundImage: `url("${process.env.NEXT_PUBLIC_API_URL}/assets/images/errors/bg-404.png")`,
    };

    const shpaImage = {
        backgroundImage: `url("${process.env.NEXT_PUBLIC_API_URL}/assets/images/errors/star-glow.png")`,
    };

    const trans = (text) => text;

    useEffect(() => {
        const header = document.querySelector(".header");
        const footer = document.querySelector(".footer-area");

        if (header) header.style.display = "none";
        if (footer) footer.style.display = "none";

        return () => {
            // Reset visibility when user leaves 404 page
            if (header) header.style.display = "";
            if (footer) footer.style.display = "";
        };
    }, []);

    return (
        <div className="frontend">
            <div
                className="error-page d-flex align-items-center"
                style={{
                    ...backgroundImage,
                    minHeight: "100vh", // full screen
                }}
            >
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-xl-7 col-lg-9 col-md-10 text-center">
                            <Image
                                src={notFoundImage}
                                alt="404 Not Found"
                                width={745}
                                height={265}
                                priority
                            />

                            <span
                                className="star-glow glow-1"
                                style={shpaImage}
                            ></span>
                            <span
                                className="star-glow glow-2"
                                style={shpaImage}
                            ></span>
                            <span
                                className="star-glow glow-3"
                                style={shpaImage}
                            ></span>
                            <span
                                className="star-glow glow-4"
                                style={shpaImage}
                            ></span>

                            <h2 className="error-page__title">
                                {trans("Page not found")}
                            </h2>
                            <p className="error-page__desc">
                                {trans(
                                    "page you are looking for doesn't exist or an other error ocurred"
                                )}
                                <br />
                                {trans("or temporarily unavailable.")}
                            </p>

                            <Link
                                href="/"
                                className="btn btn--base mt-lg-4 mt-3"
                            >
                                <span className="icon">
                                    <i className="fas fa-home"></i>
                                </span>
                                <span className="text">
                                    {trans("Go to Home")}
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
